module.exports = __webpack_public_path__ + "assets/time-error-d9dcec.svg";